import React from 'react'
import { NavLink } from 'react-router-dom'
import { useViewport } from '../../../utils'

const tabs = [
  {
    label: 'About',
    to: '/dashboard/organization/profile'
  },
  {
    label: 'Branches',
    to: '/dashboard/organization/profile/branches'
  },
  {
    label: 'Team Member',
    to: '/dashboard/organization/profile/team-member'
  },
  {
    label: 'Contact & Location',
    to: '/dashboard/organization/profile/contact-location'
  },
  {
    label: 'Milestones',
    to: '/dashboard/organization/profile/milestones'
  },
  {
    label: 'Social Media',
    to: '/dashboard/organization/profile/social-media'
  },
  {
    label: 'Partners',
    to: '/dashboard/organization/profile/partners'
  },
  {
    label: 'Featured Items',
    to: '/dashboard/organization/profile/featured-items'
  },
  {
    label: 'Visibility',
    to: '/dashboard/organization/profile/visibility'
  },
]

const TabItem = ({to, text, icon, className, accent, uppercase, embed, small}) => {
  const accented = accent ? 'font-accent' : ''
  const uppercaseClass = uppercase ? 'uppercase' : ''

  return (
    <NavLink
      className={`cursor-pointer flex border-primary opacity-50 ${className}`}
      activeClassName="border-b-2 lg:border-b-4 opacity-100"
      to={to}
      exact
    >
      {
        icon &&
        <div className="hidden lg:block mr-2">
          {icon}
        </div>
      }
      <p className={`font-bold text-center lg:text-left ${embed ? 'text-xs' : 'text-sm'} ${small ? 'lg:text-sm' : 'lg:text-base'} ${accented} ${uppercaseClass}`}>
        {text}
      </p>
    </NavLink>
  )
}

const ListNav = ({className}) => {
  const { isDesktop } = useViewport()

  return isDesktop ? (
    <div className={`flex border-b mb-10 ${className}`}>
      {
        tabs.map((t, index) => {
          const className = index === 0 ? '' : 'ml-6'
          return <TabItem
            key={index}
            text={t.label}
            to={t.to}
            className={`pb-2 ${className}`}
            small
          />
        })
      }
    </div>
  ) : (
    <div className={`flex border-b mb-8 lg:mb-5 w-full overflow-x-auto ${className}`}>
      {
        tabs.map((t, index) => {
          return <TabItem
            key={index}
            text={t.label}
            to={t.to}
            className={`whitespace-no-wrap p-4`}
            embed
          />
        })
      }
    </div>
  )
}

export { ListNav }
